import { ReactNode } from "react";
import { ChainId } from "@looksrare/config";
import { GameProvider } from "@looksrare/uikit";
import { PtbConfig } from "@looksrare/poke-the-bear";
import { useGlobalStore } from "@looksrare/utils";
import { gameAddresses } from "config/games";

export const LRPtbProvider = ({ children }: { children: ReactNode }) => {
  const [isMuted, toggleMute] = useGlobalStore((state) => [state.isPtbSoundMuted, state.togglePtbSoundMuted]);
  return (
    <GameProvider<PtbConfig>
      widgetBotOptions={{
        server: "907171253947858974",
        channel: "1168872328021684314",
        shard: "https://emerald.widgetbot.io",
        glyph: ["/images/win/chat.png", "32px"],
        color: "#04CD58",
        // override the responsive default css
        css: `button { right: 20px; bottom: 20px; border-bottom-right-radius: 56px; }`,
      }}
      supportedNetworks={["arbitrum", "ethereum"]}
      addresses={gameAddresses}
      fallbackChainId={ChainId.ARB_MAINNET}
      config={{
        refundCutoffSec: 24 * 60 * 60,
        hideCaveBackground: false,
        showLocalMuteButton: true,
        isMuted,
        hotNetwork: "arbitrum",
        renderHistoryPageTopClaimBox: true,
        historyPageWinnerProfileClickable: true,
        showMobileHeader: true,
        actions: { toggleMute },
        isWalletBlocked: false,
        points: {
          enabled: false,
        },
      }}
    >
      {children}
    </GameProvider>
  );
};
